
namespace TabAurous.Retail {

    @Serenity.Decorators.registerClass()
    export class ReceiptDenominationDetailsGrid extends Serenity.EntityGrid<ReceiptDenominationDetailsRow, any> {
        protected getColumnsKey() { return 'Retail.ReceiptDenominationDetails'; }
        protected getDialogType() { return ReceiptDenominationDetailsDialog; }
        protected getIdProperty() { return ReceiptDenominationDetailsRow.idProperty; }
        protected getInsertPermission() { return ReceiptDenominationDetailsRow.insertPermission; }
        protected getLocalTextPrefix() { return ReceiptDenominationDetailsRow.localTextPrefix; }
        protected getService() { return ReceiptDenominationDetailsService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}